




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LoginModule from '~/store/login';
import SessionModule from '~/store/session';

@Component<Header>({})
export default class Header extends Vue {
    @Resolve
    session!: SessionModule;

    handleHomeClick() {
        this.session.isAuthenticated ? this.$router.push({ path: '/Dashboard' }).catch(err => {}) : this.$router.push({ path: '/' }).catch(err => {});
    }
}
